"use strict";

angular.module("internal.exams").controller("InternalExamSkillCategory", [
    "$scope",
    "$stateParams",
    "EXSkillCategory",
    "$state",
    "$window",
    function (
        $scope,
        $stateParams,
        EXSkillCategory,
        $state,
        $window
    ) {
        $scope.SkillCategory = {};
        $scope.skillsLoading = false;
        $scope.saveMessage = $stateParams.saveMessage;
        $window.scrollTo(0, 0);

        if ($stateParams.examSkillCategoryID != null) {
            EXSkillCategory.getcategory($stateParams.examSkillCategoryID).then(
                function (SkillCategory) {
                    $scope.SkillCategory = SkillCategory[0];
                }
            );
        } else {
            // stops new record from loading perpetually
            $scope.SkillCategory.skills = [];
        }

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.skill",
                    params: [
                        {
                            name: "examSkillID",
                            field: "id"
                        }
                    ]
                }
            },
            {
                label: "Code",
                field: "code"
            },
            {
                label: "Active",
                field: "active",
                type: "yesno"
            },
            {
                label: "Critical",
                field: "critical",
                type: "yesno"
            },
            {
                label: "Last Modified",
                field: "modified_on",
                type: "date"
            }
        ];

        $scope.save = function () {
            $scope.saving = true;
            EXSkillCategory.save($scope.SkillCategory).then(function (SkillCategory) {
                $scope.saving = false;
                if (SkillCategory != null) {
                    $state.go("internal.exams.administrative.skillcategory", { examSkillCategoryID: SkillCategory[0].id, saveMessage: "Record updated successfully" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                }
            });
        };

        $scope.delete = function () {
            $scope.deleting = true;

            if ($scope.SkillCategory.skillcount != null && $scope.SkillCategory.skillcount > 0) {
                $scope.saveMessage = "Please re-assign the associated skills to a different category in order for deletion.";
                $window.scrollTo(0, 0);
                $scope.deleting = false;
            } else {
                if (window.confirm("Are you sure you want to delete this skill category?")) {
                    EXSkillCategory.delete($scope.SkillCategory.id).then(function () {
                        $scope.deleting = false;
                        $state.go("internal.exams.administrative.skillcategories", {}, { reload: "internal.exams.administrative.skillcategories" });
                    }
                    );
                } else {
                    $scope.deleting = false;
                }
            }
        };
    }
]);
